// src/components/DebugToken.js
import React from "react";
import { useAuth } from "../context/AuthContext";

const DebugToken = () => {
  const { currentUser } = useAuth();

  const fetchToken = async () => {
    if (currentUser) {
      try {
        const token = await currentUser.getIdToken(true);
        alert("Firebase ID Token:\n" + token);
      } catch (error) {
        console.error("Error fetching token:", error);
      }
    } else {
      alert("No user is logged in.");
    }
  };

  return (
    <div>
      <button onClick={fetchToken}>Get Firebase ID Token</button>
    </div>
  );
};

export default DebugToken;
